import { dropdownValuesService } from "services";

let requestCache:
	| {
			id: string | number;
			name: string;
	  }[]
	| null = null;

const loadSponsors = async search => {
	try {
		if (requestCache === null || search.length === 0) {
			requestCache = await dropdownValuesService.getSponsors();
		}

		return {
			options: requestCache?.filter(item =>
				item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
			),
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const sponsorColumn = () => ({
	name: "sponsor",
	type: "select" as const,
	loadOptions: loadSponsors,
	getOptionLabel: option => option.name,
	getOptionValue: option => option.id,
	placeholder: "Sponsor",
});

export default sponsorColumn;
